module.exports = __webpack_public_path__ + "img/3.d4b369f8.png";